import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkDisableEdits } from '../types';

const onDisableEdits: IThunkDisableEdits = thunk(async (_, { clinicId, data }) => {
  await api.clinic.disableClinicEdits(clinicId, data);
});

export default onDisableEdits;
